<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F3IIuP/tc-custom/9781398442177.jpg?1674922437401" alt="This image is the cover for the book The Anemone Bowl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Anemone Bowl
      </h1>
      <p class="bookDescription body article font2">
        <p>The tale of an afterlife. “If the inability to see other than that which you wish to see can be considered a kind of heaven, then presumably the inability to escape self-knowledge must be one version of hell.” The ill-fated consequences of happenstance: Born into an English country village community in the 1950s, a young boy is led, through a series of events over which he in effect has little or no control, to take the life of a neighbour’s child, and subsequently his own. And this is the tale, if there can be any, of the subsequent accounting. The book itself is set in an ever-mutating afterlife that also provides an interim existence before rebirth – an illusory world where, of necessity, it is in large part conveniently repressed memories that hold sway, and where for Eric (if we can suppose that to be his name), each step forward is also leading (with some level of perversity) to the truths of his own personal past transgressions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Geoff Olton
      </h2>
      
      <p class="authorDescription body article">Born on the outskirts of Manchester, Northern England, in 1946, Geoff Olton attended St Peter’s College, Oxford, majoring in mathematics. After failing final examinations, he spent one year teaching English to Saudi Arabian Air Force cadets before moving to Kobe, Japan, where he has since lived for 50 years working in teaching, interpretation and translation. Writing includes a memoir, The Way We Are, published by Austin Macauley Publishers Ltd (2022), and also a (as yet unpublished) 5,000-page analysis of the spoken English language in its relationship to Japanese and similarly grouped languages.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a389dfd